import styled from 'styled-components'
import { theme } from '../theme/theme'
import { BodyMedium, Title4 } from './styles/Typography'
import { useTranslation } from 'react-i18next'
import { Calendar } from './icons'
import { BlockItem } from './BlockItem'
import { LinkButton } from './buttons/link/LinkButton'
import { useWindowWidth } from '../hooks/useWindowWidth'
import { isTablet, isMobile } from '../utils/devices'

export const RenewScreening = () => {
  const width = useWindowWidth()
  const isMobileDevice = isTablet(width) || isMobile(width)
  const { t } = useTranslation()
  return (
    <RenewScreeningWrapper>
      <BlockItem backgroundColor={theme.color.plumMid} textColor={theme.color.white}>
        <ContentContainer $isMobileDevice={isMobileDevice}>
          <TextWrapper $isMobileDevice={isMobileDevice}>
            <TitleWrapper>
              <Circle>
                <Calendar color={theme.color.white} />
              </Circle>
              <Title4>{t('employee.screening.renewScreeningTitle')}</Title4>
            </TitleWrapper>
            <BodyMedium>{t('employee.screening.renewScreeningDescription')}</BodyMedium>
          </TextWrapper>
          <LinkButton
            href="/portal/health-services/screening"
            text={t('employee.screening.renewScreeningButton')}
            secondary={true}
            buttonColor={theme.color.white}
            buttonStyle={{ minWidth: 'fit-content' }}
          />
        </ContentContainer>
      </BlockItem>
    </RenewScreeningWrapper>
  )
}

const RenewScreeningWrapper = styled.div`
  margin-top: ${theme.spacing.xxlarge}px;
`
const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${theme.spacing.medium}px;
  margin-bottom: ${theme.spacing.medium}px;
`
const TextWrapper = styled.div<{ $isMobileDevice: boolean }>`
  padding-bottom: ${({ $isMobileDevice }) => ($isMobileDevice ? theme.spacing.xlarge : 0)}px;
  width: ${({ $isMobileDevice }) => ($isMobileDevice ? '100%' : '70%')};
`

const Circle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ContentContainer = styled.div<{ $isMobileDevice: boolean }>`
  display: flex;
  flex-direction: ${({ $isMobileDevice }) => ($isMobileDevice ? 'column' : 'row')};
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing.mediumLarge}px ${theme.spacing.large}px;

  @media screen and (max-width: ${theme.breakpoint.large}px) {
    width: 100%;
    height: 100%;
    a {
      width: 100%;
    }
  }
`
